import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  HttpClientModule,
  HttpClientJsonpModule,
  HttpClient,
} from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
//import { FacebookModule } from "ngx-facebook/dist/esm/index";
//import { ShareButtonsModule } from "ngx-sharebuttons/buttons"; // Corrected import path
//import { ShareIconsModule } from "ngx-sharebuttons/icons";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgxPaginationModule } from "./pagination/ngx-pagination.module";

import { HttpService } from "./services/http.service";

import { AppComponent } from "./app.component";
import { ViewAreaComponent } from "./components/view-area/view-area.component";
import { MapViewComponent } from "./components/map-view/map-view.component";
import { ListViewComponent } from "./components/list-view/list-view.component";
import { ViewDetailComponent } from "./components/view-detail/view-detail.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { HeaderComponent } from "./components/header/header.component";
import { MapComponent } from "./components/map-view/map/map.component";
import { SearchMapComponent } from "./components/map-view/search/search.component";
import { SearchListComponent } from "./components/list-view/search/search.component";
import { FilterComponent } from "./components/filter/filter.component";
import { LegendComponent } from "./components/legend/legend.component";
import { TableComponent } from "./components/list-view/table/table.component";
import { UserFeedbackComponent } from "./components/view-detail/user-feedback/user-feedback.component";
import { PopupDownloadComponent } from "./components/popup-download/popup-download.component";
import { ComponentTestComponent } from "./pagination/testing/testing-helpers";
import { LoginComponent } from "./components/login/login.component";
import { ExtractComponent } from "./components/extract/extract.component";
import { MultiAreasComponent } from "./components/map-view/multi-areas/multi-areas.component";

import { PLATFORM_ID, APP_ID, Inject } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { FeedbackComponent } from "./components/feedback/feedback.component";
import { AmbassadorsComponent } from "./components/ambassadors/ambassadors.component";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    ViewAreaComponent,
    MapViewComponent,
    ListViewComponent,
    ViewDetailComponent,
    PageNotFoundComponent,
    HeaderComponent,
    MapComponent,
    SearchMapComponent,
    SearchListComponent,
    FilterComponent,
    LegendComponent,
    TableComponent,
    UserFeedbackComponent,
    PopupDownloadComponent,
    LoginComponent,
    ComponentTestComponent,
    FeedbackComponent,
    ExtractComponent,
    AmbassadorsComponent,
    MultiAreasComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: "yuudachi" }),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    //FacebookModule.forRoot(), // If ngx-facebook requires .forRoot()
    //ShareButtonsModule, // Removed .forRoot()
    //ShareIconsModule,   // Added ShareIconsModule for default icons
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxPaginationModule,
    AppRoutingModule,
  ],
  providers: [HttpService],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(APP_ID) private appId: string
  ) {}
}
